<script>
  // Dropdown body for picking a JobTread budget item, grouped by cost group or
  // cost code (the active lens). Used by the direct-bill review screen for both
  // per-line and bulk assignment.
  import { createEventDispatcher } from 'svelte';
  import { costTypeLabel } from '../lib/costSplit.js';

  export let buckets = [];
  export let activeLens = 'costGroup';
  export let formatCurrency = (n) => n;
  export let cleanName = (s) => s;
  export let showCostTypes = false;

  const dispatch = createEventDispatcher();
</script>

<div
  class="absolute z-50 mt-1 w-full bg-white shadow-lg max-h-48 rounded-md py-1 text-xs ring-1 ring-black ring-opacity-5 overflow-auto"
  on:wheel|stopPropagation
  on:mousedown|preventDefault
>
  {#if buckets.length === 0}
    <div class="text-gray-500 px-3 py-2">No items found</div>
  {:else}
    {#each buckets as bucket, bucketIndex}
      {#if bucket.lineItems.length > 0}
        <div class="px-2 py-1 text-[10px] font-semibold text-gray-500 bg-gray-50">
          {#if activeLens === 'costCode'}
            {bucket.name}
          {:else}
            {#if bucket.parentCostGroup?.parentCostGroup?.name}<span class="font-normal text-gray-400">{cleanName(bucket.parentCostGroup.parentCostGroup.name)} &#8250; </span>{/if}{#if bucket.parentCostGroup?.name}<span class="font-normal">{cleanName(bucket.parentCostGroup.name)} &#8250; </span>{/if}{cleanName(bucket.name) || `Group ${bucketIndex + 1}`}
          {/if}
        </div>
        {#each bucket.lineItems as costItem}
          <div
            role="button"
            tabindex="0"
            class="group cursor-pointer select-none relative py-1.5 pl-4 pr-2 hover:bg-blue-500 hover:text-white text-xs"
            on:mousedown|preventDefault={() => dispatch('select', costItem)}
            on:keydown={(e) => e.key === 'Enter' && dispatch('select', costItem)}
          >
            <div class="flex flex-col">
              <span class="font-medium">
                {#if activeLens === 'costCode' && costItem.costCode?.number}<span class="text-[10px] font-mono text-gray-400 group-hover:text-blue-100 mr-1">{costItem.costCode.number}</span>{/if}{costItem.name}
                {#if showCostTypes}<span class="ml-1 text-[9px] font-normal px-1 rounded bg-gray-100 text-gray-500 group-hover:bg-blue-400 group-hover:text-white">{costTypeLabel(costItem)}</span>{/if}
              </span>
              <span class="text-[10px] text-gray-500 group-hover:text-white">
                {#if activeLens === 'costCode'}
                  {#if costItem.costGroup?.name}in: {#if costItem.costGroup.parentCostGroup?.parentCostGroup?.name}{cleanName(costItem.costGroup.parentCostGroup.parentCostGroup.name)} &#8250; {/if}{#if costItem.costGroup.parentCostGroup?.name}{cleanName(costItem.costGroup.parentCostGroup.name)} &#8250; {/if}{cleanName(costItem.costGroup.name)} · {/if}{formatCurrency(costItem.cost || 0)}
                {:else}
                  {#if costItem.costCode}({costItem.costCode.number} {costItem.costCode.name}) - {/if}{formatCurrency(costItem.cost || 0)}
                {/if}
              </span>
            </div>
          </div>
        {/each}
      {/if}
    {/each}
  {/if}
</div>
